import { useEffect } from 'react';
import { App } from '@capacitor/app';
import { Capacitor, PluginListenerHandle } from '@capacitor/core';
import { handleNativeAuthUrl } from '../../../../services/nativeAuthReturn';

/**
 * Listens for the `oraapp://auth` deep link that finishes a native Google /
 * Apple sign-in or account link (ORA-987). Mounted once at the app root, so a
 * sign-in started anywhere (the auth page, /unlock, the webinar modal, the
 * Security tab) completes, not only while the auth page is on screen.
 */
const NativeAuthUrlListener = () => {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    let listener: PluginListenerHandle | null = null;
    let isUnmounted = false;

    void App.addListener('appUrlOpen', (event) => {
      void handleNativeAuthUrl(event.url);
    }).then((handle) => {
      if (isUnmounted) {
        void handle.remove();
      } else {
        listener = handle;
      }
    });

    return () => {
      isUnmounted = true;
      void listener?.remove();
    };
  }, []);

  return null;
};

export default NativeAuthUrlListener;
